import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-mint-success',
  templateUrl: './mint-success.component.html',
  styleUrls: ['./mint-success.component.css', '../../../customerFace.css'],
  animations: [
    trigger('inAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('375ms cubic-bezier(.67,.52,.34,.82)', style({ opacity: 1 }))
      ])
    ])
  ],
  standalone: false
})

export class MintSuccessComponent implements OnInit {

  fakeEmail = false;

  customerName = '';
  customerEmail = '';
  paymentAmount = 0;
  paymentCurrency = 'GBP';
  tradingLogo = '';
  tradingName = '';
  systemMessage = '';
  tradingEmail = '';
  tradingPhone = '';

  constructor(private location: Location, private route: ActivatedRoute) {
    this.location.replaceState('');
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {

      this.customerName = params.customerName;
      this.customerEmail = params.customerEmail;
      this.paymentAmount = Number(params.paymentAmount);
      this.paymentCurrency = params.currency || 'GBP';
      this.tradingLogo = params.tradingLogo;
      this.tradingName = params.tradingName;
      this.tradingEmail = params.tradingEmail;
      this.tradingPhone = params.tradingPhone;

      if (this.customerEmail.substring(0, 4) === 'cust' && this.customerEmail.includes('@thetravelnetworkgroup.co.uk')) {
        this.fakeEmail = true;
      }
    });
  }
}
